const SCREEN_TITLE:string="Content Sets";
const INTRO_TEXT="Use this page to create sets of images to use with the games on this site.  After creating a set, a link will appear at the bottom of the page.  You can follow the link to play a game with your set of images."
const CHINA_TEXT="China warning - any sets you create may not be accessible for students in China.";

export const ContentHeader=function(){
    return(
        <div>
            <h3>{SCREEN_TITLE}</h3>
            <p>{INTRO_TEXT}</p>
            <p>{CHINA_TEXT}</p>
        </div>
    );
}